import * as React from "react";
import * as ReactDOM from "react-dom";
import Ajax from "../Ajax";

interface IFormProps {
}
interface MyStates {
  count: number
  offset: number
}
export default class Statusfix extends React.Component<IFormProps, MyStates>{
  private offset_increment = 10

  constructor(props:IFormProps) {
    super(props);

    this.state = {
      count: 0,
      offset: -10
    }

    this.countCustomers()
  }

  private countCustomers() {
      var ajax = new Ajax(window.location.origin + "/statusfix/api/countProducts");
      ajax.doPost({}).then(response => {
          this.setState({
              count: response.count
          });
      });
  }

  private modProducts() {
    this.setState({
      offset: this.state.offset + this.offset_increment
    }, () => {

        var ajax = new Ajax(window.location.origin + "/statusfix/api/modProducts");
        ajax.doPost({offset: this.state.offset, limit: this.offset_increment}).then(response => {
          if( this.state.offset < this.state.count ){
            this.modProducts()
          }
        });

    });
  }


  public render() {
      return (
      <>
        <div className="row" style={{marginTop: "50px"}}>
          <div className="col-sm-6">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Utólagos Statusfix</h5>
              </div>
              <div className="card-body">
                <p>Termékek száma: { this.state.count > 0 ? this.state.count + " db" : "Számolás alatt.." }</p>
                <p>Migrálás: { this.state.count > 0 ? this.state.count + " db" : "Számolás alatt.." } / { this.state.offset }</p>
                <button type="button" className="btn btn-primary" onClick={() => this.modProducts()}>Migrálás elkezdése</button>
              </div>
            </div>
          </div>
        </div>
      </>
      );
  }
}

export class InitWannabeeStatusfix {
  constructor() {
      var div: HTMLDivElement = document.getElementById('wannabee_statusfix') as HTMLDivElement;
      if (div !== null) {
          var data:any = div.dataset;
          ReactDOM.render(<Statusfix />, div);
      }
  }
}